import { render, staticRenderFns } from "./vasEditor.vue?vue&type=template&id=2d6f7b3a&scoped=true&"
import script from "./vasEditor.vue?vue&type=script&lang=js&"
export * from "./vasEditor.vue?vue&type=script&lang=js&"
import style0 from "./vasEditor.vue?vue&type=style&index=0&id=2d6f7b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f7b3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6f7b3a')) {
      api.createRecord('2d6f7b3a', component.options)
    } else {
      api.reload('2d6f7b3a', component.options)
    }
    module.hot.accept("./vasEditor.vue?vue&type=template&id=2d6f7b3a&scoped=true&", function () {
      api.rerender('2d6f7b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/vasEditor.vue"
export default component.exports